const teamData = [

    [{
      name: "Louis Arcelin",
      role: {
        en: 'Founder',
        fr: 'Directeur de post-production',
      },
    },
   ],

   [{
      name: "Daniel Rota",
      role: {
        en: 'Post-producers',
        fr: 'Post-producteurs',
      },
    },
    {
      name: "Jean-Marc Raygade",
      role: {
        en: 'Post-producer',
        fr: 'Post-producteur',
      },
    },
    {
      name: "Clément Du Passage",
      role: {
        en: 'Post-producer',
        fr: 'Post-producteur',
      },
    },
    {
      name: "Aurélie Lobin",
      role: {
        en: 'Post-producer',
        fr: 'Post-productrice',
      },
    }],
    
    [{
      name: "Yves Bosson",
      role: {
        en: "Head of VFX",
        fr: "Responsable VFX"
      },
      link: ["@iffincide", "https://www.instagram.com/ifficinside/?hl=fr"]
    }],

    [{
      name: "Sylvain Canaux",
      role: {
        en: "Head Colorist",
        fr: "Étalonneur"
      },
      link: ["@sylvain_canaux", "https://www.instagram.com/sylvain_canaux/?hl=fr"]
    }],

    [{
      name: "Christophe Richard",
      role: {
        en: "Head Flame Artists",
        fr: "Responsables Artiste Flame"
      },
    },
    {
      name: "Sylvian Fabre",
      role: {
        en: "Head Flame Artists",
        fr: "Responsable Artiste Flame"
      },
    }],

    [{
      name: "Tibor Bernard",
      role: {
        en: "Head IT",
        fr: "Responsable IT"
      },
    }],
  
  ]
 
  
export default teamData;
